export const WE = '/quienes-somos';
export const CATALOGUE = '/';
export const NEW_DETAIL = '/new-detail';
export const RENT_FORM = '/add-title-new';
export const TYPE_BICYCLE = '/type-bicycle';
export const DAYS_RENT = '/days-rent';
export const BICYCLE_RENT = '/bicycle-rent';
export const PRICE_RENT = '/price-rent';
export const PAYMENT_RENT = '/add-img-new';
export const HISTORY_RENT = '/history-rent';
export const CONTENT_NEW = '/content-new';
export const LINK = '/link';
export const RESUME = '/new-resume';
export const NOTIFICATION = '/notification';
export const LOGIN = '/login';
